<template>
	<div class="contents">
		<h3 class="mark">
			<div class="type">
				<span>
					<img src="../assets/result-detail-sacrifice-icon01.svg" alt="*" />あなたの潜在意識
				</span>
			</div><!-- end .type -->
			<div class="cover">
				他人本位{{sacrificeMindResult.percentageLeft}}%、自分本位{{sacrificeMindResult.percentageRight}}%
			</div><!-- end .cover -->				
		</h3><!-- end .mark -->
		<div class="sentence">
			<div class="catch">
				<span class="left">
					Detailed
				</span>
				<span class="right">
					explanation
				</span>
			</div><!-- end .catch -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr01 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>多くの人と触れ合うことで、転機を見出し、成功や成果を掴む</h2>
			<img src="../assets/result-detail-sacrifice-outleft01.svg" alt="*" class="visual" />
			<div class="caption">
				相手のために行動することが比較的に苦にならず、社交が人生の大きなテーマとなる
			</div><!-- end .caption -->
			<p>今回の診断で、あなたの潜在意識は他人本位志向が強いことが分かりました。あなたは内向度が低いため、この潜在意識と相まって、他人のために、他人が喜ぶことを積極的に行っていく特性があると言えるでしょう。</p>
			<p>あなたは、自分と関わる相手が、自分の手助けや協力によって良い変化をもたらすことを重要視する傾向があります。内向性が強い場合、「相手のためを想っていたとしても、なかなか行動に出せない」という結果が多くなりますが、外向的な人は、実際に行動に移すことができる点に大きな違いあります。あなたはチームや集団で過ごす機会はとても大切にするべきです。</p>

			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr02 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>他人に振り回されるか、他人に背中を押されるか、あなたはどちらかの人生を歩むことになる</h2>
			<img src="../assets/result-detail-sacrifice-outleft02.svg" alt="*" class="visual" />
			<div class="caption">
				自分よがりにならず、相手が何を求めているのかを理解していく
			</div><!-- end .caption -->
			<p>外向的×他人本位マインドのあなたが織りなす行動体質は、「相手のために、自分ができることをアウトプットする」というものです。</p>
			<p>これはとても良い行動体質のように思えますが、尽くす相手を間違えると、その相手からリターンを得られずに、相手がどんどんあなたを自分に依存させるような行動を取り、あなたは疲弊することになります。</p>
			<p>また、あなたがどれだけ相手にとって「質の高い」ものを与えられるのか、「与える人」としての質が、人生の様々な結果を大きく左右します。あなたの人生は、まさに「ギブアンドテイク」、どれだけ良いギブを相手に与えるかで、あなたの受け取る人生のテイク(チャンス・サポートなど)があまりにも大きく変わるのです。</p>
			<p>外向的なあなたは、自身で熟考して相手のことを考えたとしても、勘違いや有難迷惑になってしまうことも少なくありません。フランクに、より直接的に相手が求めているものを聞き出し、それを参考にギブを重ねることで、より自分らしい成功を積み上げることができると言えるでしょう。</p>
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr03 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<h2>身体的なトレーニングを積むことが、意外にもあなたの外交力をアップさせる</h2>
			<img src="../assets/result-detail-sacrifice-outleft03.svg" alt="*" class="visual" />
			<div class="caption">
				他人へのアプローチは、体力勝負。日々自分のカラダを鍛えていこう
			</div><!-- end .caption -->
			<p>自身の外向性と、他人本位なマインドを生かすために最も重要な要素の一つが、体力と言えるでしょう。より多くの人と、より深い結びつきを目指せば目指すほど、あなたには体力が求められます。</p>
			<p>体力は気力にも繋がります。高い体力を持つことで、外向的なカリスマ性や可能性があなたから湧き出て、よりレベルの高い人から理解してもらえるようになっていきます。すると、変な人から騙されることがなくなったり、あなた自身も微妙な人を感覚的に察知できるようになります。</p>
			<p>ジムなどのコミュニティの中でトレーニングをするのも良いでしょう。他人と関わる機会を持ちながら、体力を高めることもできます。外に出て身体を動かすこと自体が外向的なあなたが、自分らしさを感じられる行為です。ぜひ、身体的強度を高めて、あなたの持つ他人本位な思考とパフォーマンスを存分に高めていって下さい。</p>
		</div><!-- end .sentence -->
	</div><!-- end .contents -->			
</template>
		

<script>


export default {
	name: 'ResultDetailSacrificeOutLeft',
	components: {

	},
	
	data: function () {
		return {

		}
	},
	props:[

	],
	computed: {
		//level
		levelResult:function(){
			return this.$store.getters.levelResult
		},
		//sacrificeMind
		sacrificeMindResult:function(){
			return this.$store.getters.sacrificeMindResult
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



</style>
